import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Educational Qualification",
    ok: "OK",
    errorSelect: "Please select an option before proceeding.",
    alert: "Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    header: "शैक्षिक योग्यता",
    ok: "ठीक है",
    errorSelect: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    alert: "कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
  },
  Kn: {
    header: "ವಿದ್ಯಾರ್ಹತೆ.",
    ok: "ಸರಿ",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಆಯ್ಕೆಮಾಡಿ.",
    alert: "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
  },
};

const VictimQualification = ({
  onNext,
  onVictimQualificationSelected,
  onQuestion,
  answer,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [qualification, setQualification] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [qualificationOptions, setQualificationOptions] = useState([]);
   const [rawQualificationData, setRawQualificationData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/victimqualification.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio10.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio10.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };



  // When selected language changes, update audio element's source automatically
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Load stored qualification (if any) from localStorage on mount
  useEffect(() => {
    const storedData = localStorage.getItem("qualification");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setQualification(parsedData);
      onVictimQualificationSelected(parsedData);
    }
  }, []);


    const getQualificationList = (resp, language) => {
      switch (language) {
        case "en":
          return resp.lang_eng;
        case "Hi":
          return resp.lang_hin;
        case "Kn":
          return resp.lang_kanada;
        default:
          return resp.lang_eng; // fallback
      }
    };
  
  
    useEffect(() => {
      if (rawQualificationData) {
        const QualificationList = getQualificationList(rawQualificationData, selectedLang) || [];
        const generateId = (index) => {
          if (index < 26) {
            // For index 0-25, use uppercase letters A-Z.
            return String.fromCharCode(65 + index);
          } else if (index < 52) {
            // For index 26-51, use lowercase letters a-z.
            return String.fromCharCode(97 + index - 26);
          } else {
            // Fallback to numeric or combined identifiers if more than 52 items.
            return index.toString();
          }
        };
        setQualificationOptions(
          QualificationList.map((Qualification, index) => ({
            // id: String.fromCharCode(65 + index),
            id: generateId(index),
            value: Qualification.edqf_uniq,
            label: Qualification.edqf_nm,
          })) || []
        );
      }
    }, [selectedLang, rawQualificationData]);

  // Fetch qualification options from API
  useEffect(() => {
    const fetchQualificationData = async () => {
      try {
        const response = await fetch(`${apiUrl}/v1/cy_ma_edu_qulfs_list`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6536277ea3",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!response.ok) {
          throw new Error("Failed to fetch qualification options");
        }
        const QualificationData = await response.json();
        if (QualificationData.resp.error_code === "0") {
          setRawQualificationData(QualificationData.resp);
          // setOptions(
          //   QualificationData.resp.edu_qulfs_list.map((qual, index) => ({
          //     id: String.fromCharCode(65 + index),
          //     value: qual.edqf_uniq,
          //     label: qual.edqf_nm,
          //   })) || []
          // );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQualificationData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const handleOptionClick = async (option, e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    setQualification(option.label);
    if (option.disabled) {
      return;
    }
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_choice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f6536277ea3",
          qtion_num: "8",
          qtion_option: option.id,
          option_val: option.value,
          lac_token: botToken,
          app_ver: app_ver,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error("Failed to push data to API");
      }
      if (data.resp.error_code === "0") {
        setQualification(option.label);
        onVictimQualificationSelected(option.label);
        setShowOkButton(true);
        onNext(10);
        onQuestion(11);
        localStorage.setItem("qualification", JSON.stringify(option.label));
        setError("");
      } else {
        setError("Failed to push data to API");
      }
    } catch (err) {
      console.error("Error sending data to API:", err);
    }
  };

  const handleOkClick = (e) => {
    onVictimQualificationSelected(qualification);
    if (qualification) {
      if (audioRef.current && isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      }
      onNext(10);
      onQuestion(11);
    } else {
      setError('errorSelect');
      setShowOkButton(false);
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].header}
              <span style={{ color: "red" }}>*</span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White"  size={12} style={{ marginBottom: '20px' }}/> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }} />}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div className="option-list" style={{ position: "relative", zIndex: "9" }}>
            {qualificationOptions.map((option) => (
              <button
                key={option.id}
                className={`option-button ${qualification === option.label ? "selected" : ""}`}
                onClick={(e) => handleOptionClick(option, e)}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor: qualification === option.label ? "#000" : "#fff",
                      color: qualification === option.label ? "#fff" : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label">{option.label}</div>
                </div>
                {qualification === option.label && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", position: "relative", zIndex: "1000" }}>
            {showOkButton && (
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            )}
          </div>
        </div>
        {error && (
          <div className="error-message" style={{ position: "relative", zIndex: "1000" }}>
            {translations[selectedLang][error]}
          </div>
        )}
        {answer[9] && (
          <p className="alert-box">
            {translations[selectedLang].alert}
          </p>
        )}
      </div>
    </div>
  );
};

export default VictimQualification;
